import { AdminDeviceResponse } from '../devices/types';
import { httpClient } from '../http';
import { MutationRequest, NoContent, PaginatedResponse, PaginationQueryParams } from '../types';
import {
	CreateCustomerRequest,
	CustomerResponse,
	CustomerSiteOption,
	CustomerSitesResponse,
	CustomerUsersQueryParams,
	CustomersQueryParams,
	UpdateCustomerRequest,
} from './types';
import { CustomerUserResponse } from '../users/types';

export const getCustomers = async (
	queryParams?: CustomersQueryParams
): Promise<PaginatedResponse<CustomerResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<CustomerResponse>>('/customers', {
		params: queryParams,
	});

	return data;
};

export const getCustomerSiteOptions = async (customerId: string): Promise<CustomerSiteOption[]> => {
	const { data } = await httpClient.get<CustomerSiteOption[]>(
		`/customers/${customerId}/sites/reduced`
	);

	return data;
};

export const getCustomerUsers = async (
	id: string,
	queryParams?: CustomerUsersQueryParams
): Promise<PaginatedResponse<CustomerUserResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<CustomerUserResponse>>(
		`/customers/${id}/users`,
		{ params: queryParams }
	);

	return data;
};

export const getCustomerDevices = async (
	id: string,
	queryParams: PaginationQueryParams
): Promise<PaginatedResponse<AdminDeviceResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<AdminDeviceResponse>>(
		`/customers/${id}/devices`,
		{ params: queryParams }
	);

	return data;
};

export const getCustomerSites = async (): Promise<CustomerSitesResponse[]> => {
	const { data } = await httpClient.get<CustomerSitesResponse[]>('/customers/sites');

	return data;
};

export const getCustomer = async (id: string): Promise<CustomerResponse> => {
	const { data } = await httpClient.get<CustomerResponse>(`/customers/${id}`);

	return data;
};

export const createCustomer = async ({
	request,
	formKey,
}: MutationRequest<CreateCustomerRequest>): Promise<CustomerResponse> => {
	const { data } = await httpClient.post<CustomerResponse>('/customers', request, {
		headers: { formKey },
	});

	return data;
};

export const updateCustomer = async (
	id: string,
	{ request, formKey }: MutationRequest<UpdateCustomerRequest>
): Promise<CustomerResponse> => {
	const { data } = await httpClient.patch<CustomerResponse>(`/customers/${id}`, request, {
		headers: { formKey },
	});

	return data;
};

export const deleteCustomer = async (id: string): Promise<NoContent> => {
	const { data } = await httpClient.delete<NoContent>(`/customers/${id}`);

	return data;
};
